import { DropdownOption } from 'components/form/Dropdown';

import { GroupModel } from '../../models/students/GroupModel';

export const getGroupsOptions = (groups: GroupModel[]): DropdownOption[] =>
  groups.map((c) => ({
    key: c.id,
    label: c.name,
  }));
